import styled from '@emotion/styled'
import sgProgressIndicator from 'img/SG_progress_indicator_animated.gif'

export const AnimatedChecLoading = styled.span((props) => {
  const { width, height } = props

  return `
    background: url(${sgProgressIndicator}) no-repeat;
    background-size: ${width}px;
    width: ${width}px;
    height: ${height}px;
    background-position: center;
  `
})

export const GifContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
`
